import React from 'react';
import LegalDocument from './LegalDocument';

const PrivacyPolicy = () => {
  return <LegalDocument documentIdBase="privacy_policy" />;
};

export default PrivacyPolicy;
